(() => {
  function init(root) {
    if (root.dataset.rvReady) return;
    const variants = JSON.parse(root.querySelector('[data-product-variants]').textContent);
    const form = root.querySelector('.rv-product-form');
    const select = form.querySelector('[data-variant-select]');
    const quantity = form.querySelector('[data-quantity]');
    const submit = form.querySelector('[data-add-button]');
    const message = form.querySelector('[data-form-message]');
    const buttons = [...form.querySelectorAll('[data-option-index]')];
    const stockText = JSON.parse(root.querySelector('[data-stock-text]').textContent);
    let selected = variants.find(v => String(v.id) === select.value) || variants[0];
    let options = [...selected.options], busy = false;
    const money = cents => new Intl.NumberFormat(root.dataset.locale || 'it', {style:'currency', currency:root.dataset.currency || 'EUR'}).format(cents / 100);
    const box = () => form.querySelector('[name="rv_box"]:checked');
    const coupon = () => (form.querySelector('[data-coupon]')?.value || '').trim();
    const showMedia = id => {
      if (!root.querySelector(`[data-media-id="${id}"]`)) return;
      root.querySelectorAll('[data-media-id]').forEach(panel => {
        panel.hidden = panel.dataset.mediaId !== String(id);
        if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      root.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
    };
    function updateTotal() {
      const choice = box(), hasBox = !!choice?.value;
      form.querySelector('[data-total-price]').textContent = money(((selected?.price || 0) + Number(choice?.dataset.price || 0)) * Number(quantity.value || 1));
      const express = form.querySelector('[data-express]');
      if (express) express.hidden = hasBox || !!coupon() || !selected?.available;
      const note = form.querySelector('[data-box-checkout-note]');
      if (note) note.hidden = !hasBox;
    }
    function update(changeUrl = false) {
      selected = variants.find(v => v.options.every((value, i) => value === options[i]));
      buttons.forEach(button => {
        const index = Number(button.dataset.optionIndex), value = button.dataset.optionValue;
        const available = variants.some(v => v.available && v.options[index] === value);
        button.disabled = !available;
        button.classList.toggle('rv-unavailable', !available);
        button.setAttribute('aria-pressed', String(options[index] === value));
      });
      form.querySelectorAll('[data-option-selected]').forEach(label => { label.textContent = options[Number(label.dataset.optionSelected)] || ''; });
      if (selected) {
        select.value = String(selected.id);
        root.querySelector('[data-variant-price]').textContent = money(selected.price);
        const compare = root.querySelector('[data-compare-price]');
        compare.hidden = !(selected.compare_at_price > selected.price);
        compare.textContent = compare.hidden ? '' : money(selected.compare_at_price);
        quantity.min = String(selected.min || 1);
        quantity.step = String(selected.step || 1);
        if (selected.max !== null) quantity.max = String(selected.max); else quantity.removeAttribute('max');
        const max = selected.max === null ? Infinity : selected.max;
        quantity.value = String(Math.max(selected.min || 1, Math.min(max, Number(quantity.value) || 1)));
        if (selected.media_id) showMedia(selected.media_id);
        if (changeUrl) {
          const url = new URL(location.href); url.searchParams.set('variant', selected.id); history.replaceState({}, '', url);
        }
        select.dispatchEvent(new Event('change', {bubbles:true}));
      }
      submit.disabled = busy || !selected?.available;
      form.querySelector('[data-add-label]').textContent = selected?.available ? root.dataset.add : root.dataset.unavailable;
      root.querySelector('[data-stock-label]').textContent = selected?.available ? stockText : root.dataset.unavailable;
      updateTotal();
    }
    root.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
    buttons.forEach(button => button.addEventListener('click', () => {
      const index = Number(button.dataset.optionIndex), value = button.dataset.optionValue;
      options[index] = value;
      if (!variants.some(v => v.available && v.options.every((o,i) => o === options[i]))) {
        const candidates = variants.filter(v => v.available && v.options[index] === value);
        const score = v => v.options.reduce((sum,o,i) => sum + (o === options[i] ? 1 : 0), 0);
        candidates.sort((a,b) => score(b) - score(a));
        if (candidates[0]) options = [...candidates[0].options];
      }
      message.textContent = ''; update(true);
    }));
    form.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
      const next = Number(quantity.value) + Number(button.dataset.quantityChange) * Number(quantity.step || 1);
      if (next >= Number(quantity.min) && (!quantity.max || next <= Number(quantity.max))) { quantity.value = String(next); message.textContent = ''; }
      else message.textContent = root.dataset.limit;
      updateTotal();
    }));
    quantity.addEventListener('input', updateTotal);
    form.querySelectorAll('[name="rv_box"]').forEach(input => input.addEventListener('change', updateTotal));
    form.querySelector('[data-coupon]')?.addEventListener('input', updateTotal);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !selected?.available) return;
      if (!form.reportValidity()) return;
      const count = Number(quantity.value);
      if (!Number.isInteger(count) || count < Number(quantity.min) || (quantity.max && count > Number(quantity.max)) || (count - Number(quantity.min)) % Number(quantity.step || 1)) { message.textContent = root.dataset.limit; return; }
      busy = true; submit.disabled = true; form.setAttribute('aria-busy','true'); message.textContent = '';
      form.querySelector('[data-add-label]').textContent = root.dataset.adding;
      const items = [{id:selected.id, quantity:count}];
      const choice = box();
      if (choice?.value) items.push({id:Number(choice.value), quantity:count, parent_id:selected.id});
      try {
        const route = (window.Shopify?.routes?.root || root.dataset.root || '/').replace(/\/?$/, '/');
        const response = await fetch(route + 'cart/add.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : root.dataset.error);
        const cartUrl = root.dataset.cartUrl || '/cart';
        const nextUrl = coupon() ? route + 'discount/' + encodeURIComponent(coupon()) + '?redirect=' + encodeURIComponent(cartUrl) : cartUrl;
        if (root.dispatchEvent(new CustomEvent('rv:cart-added', {bubbles:true, cancelable:true, detail:{items:data.items, redirect:nextUrl}}))) location.assign(nextUrl);
      } catch (error) { message.textContent = error.message || root.dataset.error; }
      finally { busy = false; form.removeAttribute('aria-busy'); update(); }
    });
    form.querySelector('.rv-native-variants').hidden = true;
    form.querySelectorAll('.rv-js-variants,.rv-boxes,.rv-coupon,.rv-order-total,[data-quantity-change]').forEach(el => { el.hidden = false; });
    update(); root.dataset.rvReady = 'true';
  }
  const boot = scope => scope.querySelectorAll('[data-rv-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
